// init starr js
$(document).ready(function(){
  if (checkIfExists('.product-detail')) {
    $('.product-stars').starrr({
        rating: $('.rating').data('rate'),

        change: function(e, value){
          var data = {
            _token: $('meta[name="csrf-token"]').attr('content'),
            rate: value
          }
          $.ajax({
            url: $('.rating').data('url'),
            type: 'post',
            data: data,
            dataType: "json",
            success: function(data){
              // $('#rate-message').html(data.text);

              if (data.code == 'ok') {
                $('#rate').html('');
                $('#rate').html('Гласували: '+data.count+', Рейтинг: ' + data.rate);
              }

            }
          });
        }
    })
  }
})
